import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { FieldWasChangedIcon } from 'KnmErknmPackage/MainModule/components/FieldWasChanged/FieldWasChangedIcon';
import {
  getChecklistsPlanChanges,
  getLatestKnmErknmChangePlanReasonTypeCode,
} from 'KnmErknmPackage/MainModule/selectors/knmErknmSelectors';
import { IKnmChecklist248 } from 'APIPackage/KnmModule/interfaces/IKnmChecklist248';

type OwnProps = {
  checklistGuid?: string | null;
  checklistPlanChanges: IKnmChecklist248[];
  changeReasonCode?: string;
  checkGuid?: string | null;
  numberCheckList?: number | null;
};

type StoreProps = {};

type Props = OwnProps & StoreProps;

const ErknmChecklistRemarkChangesWithoutStore = ({
  checklistGuid,
  checklistPlanChanges,
  changeReasonCode,
  checkGuid,
  numberCheckList,
}: Props) => {
  if (changeReasonCode !== 'RSN_CHNG_PP_XXII') {
    return null;
  }
  const existCheck = checklistPlanChanges.find(item => item.guid === checkGuid);

  if (existCheck) {
    if (existCheck.checkList?.dictVersionId === checklistGuid && existCheck.ervkCheckList?.number === numberCheckList) {
      return null;
    }
  }

  return <FieldWasChangedIcon text="Добавлена новая запись или изменена существующая" />;
};

const mapStateToProps = (state: IRootState) => ({
  checklistPlanChanges: getChecklistsPlanChanges(state),
  changeReasonCode: getLatestKnmErknmChangePlanReasonTypeCode(state),
});

export const ErknmChecklistRemarkChanges = connect(mapStateToProps)(ErknmChecklistRemarkChangesWithoutStore);
